'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapResourceStateToProps = require('./mapResourceStateToProps');

function chainablePropType(predicate) {
  var propType = function propType(props, propName, componentName) {
    if (props[propName] == null) return;
    return predicate(props, propName, componentName);
  };

  propType.isRequired = function (props, propName, componentName) {
    if (props[propName] == null) {
      return new Error('Required prop `' + propName + '` was not specified in `' + componentName + '`.');
    }

    return predicate(props, propName, componentName);
  };

  return propType;
}

function isValidResource(resource) {
  return resource && resource[_mapResourceStateToProps._metaTag];
}

function resourcePropType(props, propName, componentName) {
  if (!isValidResource(props[propName])) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`, expected a `redux-supermodel` resource.');
  }

  return null;
}

exports.default = chainablePropType(resourcePropType);


//////////////////
// WEBPACK FOOTER
// ../dist/propType.js
// module id = 328
// module chunks = 0